export default __webpack_public_path__ + "9d29cdfcb20eeba70a1843c5c0e69aef.svg";